module.exports = __webpack_public_path__ + "img/banner_placeholder--mobile.2bd6aa4.png";